import React from 'react';
import PageHeader from '../components/PageHeader';
import AboutSection from '../components/AboutSection';
import TeamSection from '../components/TeamSection';
import TimelineOverview from '../components/TimelineOverview';
import NextSteps from '../components/NextSteps';

const About = () => {
  const breadcrumb = [
    { label: 'Home', href: '/' },
    { label: 'Pages', href: '#' },
    { label: 'About', href: '/about', active: true }
  ];

  return (
    <>
      <PageHeader title="About Us" breadcrumb={breadcrumb} />
      <AboutSection />
      <NextSteps/>
      <TeamSection />
    </>
  );
};

export default About;






